/* eslint-disable react/no-danger */
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import _ from 'lodash';
import { motion } from 'framer-motion';
import BoxedContainer from './layouts/BoxedContainer';
import Sprites from '../components/Sprites';

function FreeZoneTwoColTitleText({ id, data }) {
  const title = _.get(data, 'title', '');
  const description = _.get(data, 'description', '');
  const text = _.get(data, 'text', '');
  const bgImage = _.get(data, 'bgImage', {});
  const bgImageMobile = _.get(data, 'bgImageMobile', {});
  const logo = _.get(data, 'logo', {});
  const hasLine = _.get(data, 'hasLine', false);
  const isCorporate =
    typeof window !== 'undefined' && _.includes(window.location.pathname, 'value-added-services');
  const isAuthority =
    typeof window !== 'undefined' &&
    _.includes(window.location.pathname, 'dwtc-authority-packages');
  const isRegisterYourInterest =
    typeof window !== 'undefined' && _.includes(window.location.pathname, 'register-your-interest');

  return (
    <section
      id={id}
      className={`relative overflow-hidden bg-white
      `}>

{/* ${isRegisterYourInterest ? 'bg-white' : 'bg-[#fafafa] md:bg-[#f7f7f7]'} */}

      {_.isEmpty(bgImage) || (
        <LazyLoadImage
          src={bgImage.url}
          alt={title}
          className="hidden md:!block absolute inset-0 !w-full !h-full
          object-cover object-right md:object-[inherit] opacity-10"
        />
      )}
      {_.isEmpty(bgImageMobile) ? (
        _.isEmpty(bgImage) || (
          <LazyLoadImage
            src={bgImage.url}
            alt={title}
            className="md:hidden opacity-10 absolute inset-0 !w-full !h-full
            object-cover object-right md:object-[inherit]"
          />
        )
      ) : (
        <LazyLoadImage
          src={bgImageMobile.url}
          alt={title}
          className="md:hidden opacity-10 absolute inset-0 !w-full !h-full object-cover"
        />
      )}
      {hasLine && (
        <div
          className="absolute
          ltr:-right-5 ltr:lg:right-auto ltr:lg:left-0
          rtl:-left-5 rtl:lg:left-auto rtl:lg:right-0
          top-6 1xl:top-1/2
          lg:bottom-0 1xl:bottom-auto 1xl:-translate-y-1/2
          flex rtl:justify-start rtl:lg:justify-end ltr:justify-end ltr:lg:justify-start
          rtl:scale-[-1]">
          <Sprites
            name="freezone-corner-arrow"
            className="w-[20%] lg:xl:w-[30%] 2xl:w-[180px]
            3xl:w-[220px] ltr:-scale-x-100 ltr:lg:transform-none rtl:lg:scale-x-100
            rtl:scale-x-[-1] rtl:lg:transform-none"
          />
        </div>
      )}

      <BoxedContainer className="relative">
        <div
          className="py-12.5 md:py-16 lg:py-20 xl:py-25 grid gap-y-7 md:gap-x-7 grid-cols-12
        md:max-w-full">
          <div
            className="grid grid-cols-1 gap-7 md:gap-5 col-span-12 lg:col-span-5 grid-flow-row
            auto-rows-min">
            {title && (
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.5 }}
                viewport={{ once: true }}
                className={`[&>*>strong]:!font-URWDINBold [&>*>strong]:!font-bold
                child:!text-clamp20to40 child:!font-URWDINMedium child:!font-medium
                child:ltr:leading-1.125 child:rtl:leading-1.3 child:rtl:md:leading-1.2 
                child:m-0 w-[75%] md:w-[85%] lg:w-auto child:text-[#231F20]
                ${isAuthority ? 'md:max-w-[422px]' : ''}`}
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}
            {hasLine && (
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.5 }}
                viewport={{ once: true }}
                className="w-[70px] h-[2px] bg-red my-px"
              />
            )}
            {_.isEmpty(logo) || (
              <LazyLoadImage
                src={logo.url}
                alt={title}
                className={`
                  ${isCorporate
                    ? 'max-w-[160px] md:max-w-[200px]'
                    : 'w-full max-w-[230px] md:max-w-[327px]'
                  }
                  w-fit h-auto object-cover pt-2 md:pt-5
                `}
              />
            )}
          </div>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.6 }}
            viewport={{ once: true }}
            className="col-span-12 lg:col-span-7">
            <div className="grid grid-cols-1 gap-7">
              {description && (
                <div
                  className="child:text-clamp13to20 child:!font-LibreBaskervilleRegular child:m-0
                child:ltr:leading-[1.6] child:rtl:leading-[1.4] child:rtl:md:leading-[1.5] child:text-[#333]"
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              )}
              {text && (
                <div
                  className="child:text-clamp12to18 
                  child:ltr:!font-URWDINRegular 
                  child:rtl:!font-GESSTwoDWTCLight 
                  child:leading-1.4
                  child:m-0 child:text-[#4a4a4a] flex flex-col gap-y-4 md:gap-y-6"
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              )}
            </div>
          </motion.div>
        </div>
      </BoxedContainer>
    </section>
  );
}

export default FreeZoneTwoColTitleText;
